export enum ButtonType {
  primary = 'primary',
  success = 'success',
  failure = 'failure'
}
